import { NavLink, useLocation } from "react-router-dom";
import { Home, MapPin, NotebookPen, Bookmark, User } from "lucide-react";

const ITEMS = [
  { to: "/home", label: "home", icon: Home, testid: "nav-home" },
  { to: "/toronto", label: "toronto", icon: MapPin, testid: "nav-toronto" },
  { to: "/log", label: "log", icon: NotebookPen, testid: "nav-log" },
  { to: "/saved", label: "saved", icon: Bookmark, testid: "nav-saved" },
  { to: "/profile", label: "profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  // hide on landing + auth pages
  if (pathname === "/" || pathname === "/login" || pathname === "/signup") return null;
  if (pathname.startsWith("/admin")) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 bg-black border-t-2 border-white pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon, testid }) => (
          <li key={to}>
            <NavLink
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 text-[11px] font-mono lowercase transition-colors ${
                  isActive
                    ? "text-acid bg-acid/10"
                    : "text-white/70 hover:text-white"
                }`
              }
            >
              <Icon className="w-5 h-5" strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
